import { useRouter } from "next/navigation";
import { useEffect, useTransition } from "react";
import { RiRefreshLine } from "react-icons/ri";
import { useWhiteLabel } from "~/app/providers";
import { Button } from "~/components/v3/themed/Button";
import { cn } from "~/utils/fontsConfig";

const CheckSubscriptionButton = ({ hasChecked }: { hasChecked: boolean }) => {
    const customization = useWhiteLabel()?.customization;
    const [isRefreshing, startRefreshing] = useTransition();
    const router = useRouter();

    useEffect(() => {
        // perform check for subscription on mount
        startRefreshing(() => {
            router.refresh();
        });
    }, []);

    return (
        <Button
            className={cn(
                hasChecked
                    ? customization?.buttons?.default
                    : customization?.buttons?.secondary,
            )}
            disabled={isRefreshing}
            onClick={() => {
                startRefreshing(() => {
                    router.refresh();
                });
            }}
        >
            Check subscription status
            <RiRefreshLine className="h-4 w-4" />
        </Button>
    );
};

export default CheckSubscriptionButton;
